import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { FetchScheduledStreamContents, FetchScheduledStreamContentsSuccess } from 'app/library/scheduled-stream-content/actions';
import { MaxBrainScheduledStreamContent } from 'app/library/scheduled-stream-content/models/scheduled-stream-content.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

export class ScheduledStreamContentDataSource implements DataSource<MaxBrainScheduledStreamContent> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredCourseCancellation$: Observable<MaxBrainScheduledStreamContent[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<MaxBrainScheduledStreamContent[]> {
        return this._filteredCourseCancellation$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadScheduledStreamContent(
        audienceId: string,
        featuredStreamContentId: string,
        pageSize?: number,
        pageNumber?: number,
        sortBy?: string,
        sortOrder?: string,
        search?: string,
        selectedPostingTypeId?: string
    ): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchScheduledStreamContents({
                audienceId,
                featuredStreamContentId,
                pageSize,
                pageNumber: pageNumber,
                sortBy,
                sortOrder,
                search,
                selectedPostingTypeId,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchScheduledStreamContentsSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
